export default {
  name: 'DCR'
}


// WEBPACK FOOTER //
// ./src/configs/storage.js